<template>
    <div>
        <b-row id="custom-table-list-pagination-first">
            <b-col sm="12" lg="6" md="6" class="p-0">
                <b-pagination v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              aria-controls="table-list"
                              class="custom-table-list-pagination" />
            </b-col>

            <b-col sm="12" lg="6" md="6" class="h-space-between pr-0">
                
                <a v-if="isUsers" class="mr-15" href="https://api.maypro.ru/Users/Admin/GetXlsx" target="_blank" title="Экспорт в Excel">
                    <font-awesome-icon icon="file-excel" 
                                        id="fa-file-excel" 
                                        class="fa-file-excel"
                                        size="2x"
                                        color="#71bc78"/>
                </a>

                <b-input-group class="mr-15">

                    <b-input-group-prepend class="search-input-prepend">

                        <font-awesome-icon icon="search" id="search-input-prepend-icon" color="#dadada" />

                    </b-input-group-prepend>

                    <b-input id="search-input"
                             :placeholder="placeholderSearch"
                             v-model="searchText"/>
                </b-input-group>

                <b-button variant="outline-success" 
                    class="search-input-append-button" 
                    @click="moveToEdit">
                    Добавить
                </b-button>

            </b-col>
        </b-row>

        <b-table id="table-list"
                 class="custom-table-list"
                 
                 hover 
                 sort-icon-left
                 responsive="sm"
                 :per-page="perPage"
                 :current-page="currentPage" 
                
                 :fields="fields"
                 :items="copyOptions">

            <template v-if="isUsers" v-slot:cell(FullName)="data">
                
                <a :href="`${editLink}?id=${data.item.Id}`" 
                    class="custom-table-list-link"> 
                    {{ data.value }} 
                </a>

            </template>

            <template v-else v-slot:cell(Name)="data">

                <b-img v-if="data.item.ImageUrl" 
                       rounded="circle"
                       width="50"
                       class="mr-10"
                       :src="data.item.ImageUrl" />

                <router-link :to = "{ path:`${editLink}?id=${data.item.Id}`, query: { 'api-Version': apiVersion }}"
                            class="custom-table-list-link"> 
                    <div>{{ data.value  }}</div>
                    
                </router-link>

            </template>

            <template v-slot:cell(BotFormName)="data">
                
                <a :href="`${editLink}?id=${data.item.Id}`" 
                    class="custom-table-list-link"> 
                    {{ data.value }} 
                </a>

            </template>

            <template v-if="isBlocks" v-slot:cell(Activities)="data">
                
                <router-link v-for="(item, index) in data.value"
                            :key="index"
                            :to = "{ path:`${activityLink}?id=${item.Id}`, query: { 'api-Version': apiVersion }}"
                            class="custom-table-list-link"> 
                    <div>{{ item.Text }}</div>
                </router-link>
            </template>

            <template v-if="isQuestions" v-slot:cell(Blocks)="data">
                
                <router-link v-for="(item, index) in data.value"
                             :key="index"
                             :to = "{ path:`${blockLink}?id=${item.Id}`, query: { 'api-Version': apiVersion }}" 
                             class="custom-table-list-link"> 
                    <div>{{ item.Text }}</div>
                </router-link>

            </template>

        </b-table>

        <b-row id="custom-table-list-pagination-second">

                <b-pagination v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              aria-controls="table-list"
                              class="custom-table-list-pagination" />
            
        </b-row>

    </div>

</template>

<script>
import '@/assets/styles/shared/customTableList.css'

import allRoutes from '@/routes/all.routes';

export default {
    props: {
        options: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Array,
            default: () => []
        },
        perPage: {
            type: Number,
            default: 50
        },
        placeholderSearch: {
            type: String,
            default: ""
        },
        editLink: {
            type: String,
            default: ""
        },
        isUsers: {
            type: Boolean,
            default: false
        },
        isBlocks: {
            type: Boolean,
            default: false
        },
        isQuestions: {
            type: Boolean,
            default: false
        },
        apiVersion: {
            type: String,
            default: ""
        }
    },
    computed: {
        copyOptions: function() {
            if (!this.searchText || this.options.length == 0)
                return this.options;

            var fields = Object.keys(this.options[0]);

            var text = this.searchText.toLocaleLowerCase();
            
            fields = fields.filter(name => name !== "Id");

            return this.options.filter(entity => {
                for (var i = 0; i < fields.length; i++)
                    {
                        var fieldName = fields[i];
                        if (Boolean(entity[fieldName]) && String(entity[fieldName]).toLocaleLowerCase().includes(text))
                            return true;
                    }

                return false;
            });
        },
        rows: function() {
            return this.copyOptions.length;
        }
    },
    data: function () {
        return {
            
            searchText: null,
            currentPage: 1,

            activityLink: allRoutes.Admin.Activities.Edit,
            blockLink: allRoutes.Admin.Blocks.Edit
        }
    },
    methods: {
        moveToEdit: function() {
            this.$router.push({ path: this.editLink, query: { 'api-Version': this.apiVersion } })
        }
    }
    
}
</script>